import { memo } from 'react';

import ErrorOutlineIcon from '@mui/icons-material/ErrorOutlineOutlined';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';

import AppButton from '@components/common/AppButton';
import AppTypography from '@components/common/AppTypography';

const AppErrorState = memo(function AppErrorState({
  title = 'Something went wrong',
  description = 'An unexpected error occurred. Please try again.',
  onRetry,
  retryLabel = 'Try again',
  sx,
  ...rest
}) {
  return (
    <Box
      role="alert"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: 1.5,
        py: 6,
        px: 2,
        ...sx,
      }}
      {...rest}
    >
      <ErrorOutlineIcon color="error" fontSize="large" />
      <AppTypography variant="h6">{title}</AppTypography>
      {description ? (
        <AppTypography variant="body2" color="text.secondary" sx={{ maxWidth: 420 }}>
          {description}
        </AppTypography>
      ) : null}
      {onRetry ? (
        <AppButton variant="outlined" onClick={onRetry}>
          {retryLabel}
        </AppButton>
      ) : null}
    </Box>
  );
});

AppErrorState.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  onRetry: PropTypes.func,
  retryLabel: PropTypes.string,
  sx: PropTypes.object,
};

export default AppErrorState;
